/* eslint-disable */
const INGREDIENTS = {
  ALOE: 'aloe',
  ARBUTIN: 'arbutin',
  ASCORBIC: 'ascorbic',
  AZELAIC: 'azelaic',
  DMAE: 'dmae',
  DPANTHENOL: 'dpanthenol',
  FERULIC: 'ferulic',
  GLYCOLIC: 'glycolic',
  ISO: 'iso',
  KOJIC: 'kojic',
  LACTO: 'lacto',
  MADECA: 'madeca',
  NIACINAMIDE: 'niacinamide',
  PHYTIC: 'phytic',
  RETINOL: 'retinol',
  RUTIN: 'rutintx',
  SALICYLIC: 'salicylic',
  SOD: 'sod',
  ZINC: 'zinc',
  TRANEXAMIC:'tranexamic',
  RETINAL:'retinal'
};

const INGREDIENT_NAME_KEY = {
  [INGREDIENTS.ALOE]: 'section.yourIngredients.ingredient.aloe.label',
  [INGREDIENTS.ARBUTIN]: 'section.yourIngredients.ingredient.arbutin.label',
  [INGREDIENTS.ASCORBIC]: 'section.yourIngredients.ingredient.ascorbic.label',
  [INGREDIENTS.AZELAIC]: 'section.yourIngredients.ingredient.azelaic.label',
  [INGREDIENTS.DMAE]: 'section.yourIngredients.ingredient.dmae.label',
  [INGREDIENTS.DPANTHENOL]: 'section.yourIngredients.ingredient.dpanthenol.label',
  [INGREDIENTS.FERULIC]: 'section.yourIngredients.ingredient.ferulic.label',
  [INGREDIENTS.GLYCOLIC]: 'section.yourIngredients.ingredient.glycolic.label',
  [INGREDIENTS.ISO]: 'section.yourIngredients.ingredient.iso.label',
  [INGREDIENTS.KOJIC]: 'section.yourIngredients.ingredient.kojic.label',
  [INGREDIENTS.LACTO]: 'section.yourIngredients.ingredient.lacto.label',
  [INGREDIENTS.MADECA]: 'section.yourIngredients.ingredient.madeca.label',
  [INGREDIENTS.NIACINAMIDE]: 'section.yourIngredients.ingredient.niacinamide.label',
  [INGREDIENTS.PHYTIC]: 'section.yourIngredients.ingredient.phytic.label',
  [INGREDIENTS.RETINOL]: 'section.yourIngredients.ingredient.retinol.label',
  [INGREDIENTS.RUTIN]: 'section.yourIngredients.ingredient.rutintx.label',
  [INGREDIENTS.SALICYLIC]: 'section.yourIngredients.ingredient.salicylic.label',
  [INGREDIENTS.SOD]: 'section.yourIngredients.ingredient.sod.label',
  [INGREDIENTS.ZINC]: 'section.yourIngredients.ingredient.zinc.label',
  [INGREDIENTS.TRANEXAMIC]: 'section.yourIngredients.ingredient.tranexamic.label',
  [INGREDIENTS.RETINAL]: 'section.yourIngredients.ingredient.retinal.label'
};

const INGREDIENT_COLOR_CLASSES = {
  [INGREDIENTS.ALOE]: 'bg-color-skin-dryness',
  [INGREDIENTS.ARBUTIN]: 'bg-color-skin-pigmentation',
  [INGREDIENTS.ASCORBIC]: 'bg-color-skin-appearance',
  [INGREDIENTS.AZELAIC]: 'bg-color-skin-redness',
  [INGREDIENTS.DMAE]: 'bg-color-skin-appearance',
  [INGREDIENTS.DPANTHENOL]: 'bg-color-skin-dryness',
  [INGREDIENTS.FERULIC]: 'bg-color-oxidative-stress',
  [INGREDIENTS.GLYCOLIC]: 'bg-color-skin-texture',
  [INGREDIENTS.ISO]: 'bg-color-skin-appearance',
  [INGREDIENTS.KOJIC]: 'bg-color-skin-pigmentation',
  [INGREDIENTS.LACTO]: 'bg-color-pimples',
  [INGREDIENTS.MADECA]: 'bg-color-skin-appearance',
  [INGREDIENTS.NIACINAMIDE]: 'bg-color-skin-redness',
  [INGREDIENTS.PHYTIC]: 'bg-color-skin-texture',
  [INGREDIENTS.RETINOL]: 'bg-color-skin-appearance',
  [INGREDIENTS.RUTIN]: 'bg-color-skin-redness',
  [INGREDIENTS.SALICYLIC]: 'bg-color-skin-texture',
  [INGREDIENTS.SOD]: 'bg-color-oxidative-stress',
  [INGREDIENTS.ZINC]: 'bg-color-skin-oilness',
  [INGREDIENTS.RETINAL]: 'bg-color-skin-appearance',
  [INGREDIENTS.TRANEXAMIC]: 'bg-color-skin-pigmentation'
};

const INGREDIENT_DESCRIPTION_KEY = {
  [INGREDIENTS.ALOE]: 'section.yourIngredients.ingredient.aloe.description',
  [INGREDIENTS.ARBUTIN]: 'section.yourIngredients.ingredient.arbutin.description',
  [INGREDIENTS.ASCORBIC]: 'section.yourIngredients.ingredient.ascorbic.description',
  [INGREDIENTS.AZELAIC]: 'section.yourIngredients.ingredient.azelaic.description',
  [INGREDIENTS.DMAE]: 'section.yourIngredients.ingredient.dmae.description',
  [INGREDIENTS.DPANTHENOL]: 'section.yourIngredients.ingredient.dpanthenol.description',
  [INGREDIENTS.FERULIC]: 'section.yourIngredients.ingredient.ferulic.description',
  [INGREDIENTS.GLYCOLIC]: 'section.yourIngredients.ingredient.glycolic.description',
  [INGREDIENTS.ISO]: 'section.yourIngredients.ingredient.iso.description',
  [INGREDIENTS.KOJIC]: 'section.yourIngredients.ingredient.kojic.description',
  [INGREDIENTS.LACTO]: 'section.yourIngredients.ingredient.lacto.description',
  [INGREDIENTS.MADECA]: 'section.yourIngredients.ingredient.madeca.description',
  [INGREDIENTS.NIACINAMIDE]: 'section.yourIngredients.ingredient.niacinamide.description',
  [INGREDIENTS.PHYTIC]: 'section.yourIngredients.ingredient.phytic.description',
  [INGREDIENTS.RETINOL]: 'section.yourIngredients.ingredient.retinol.description',
  [INGREDIENTS.RUTIN]: 'section.yourIngredients.ingredient.rutintx.description',
  [INGREDIENTS.SALICYLIC]: 'section.yourIngredients.ingredient.salicylic.description',
  [INGREDIENTS.SOD]: 'section.yourIngredients.ingredient.sod.description',
  [INGREDIENTS.ZINC]: 'section.yourIngredients.ingredient.zinc.description',
  [INGREDIENTS.TRANEXAMIC]: 'section.yourIngredients.ingredient.tranexamic.description',
  [INGREDIENTS.RETINAL]: 'section.yourIngredients.ingredient.retinal.description'
};

export { INGREDIENTS, INGREDIENT_NAME_KEY, INGREDIENT_COLOR_CLASSES, INGREDIENT_DESCRIPTION_KEY };
